export const prUrl = `https://mt.osintsee.com/?murl=`
// export const divUrl = 'https://www.osintsee.com/mortydiv?murl='

export const googleUrl = 'https://www.google.com.hk/search?hl=zh-CN&q='
export const baiduUrl = 'https://www.baidu.com/s?wd='

// export const GOOGLE_API_KEY = "AIzaSyB7Mqg2_ge8k7X62yPrm5or9RviLmoIbrg"
export const GEMINI_PROXY_ADDRESS = "http://144.34.190.106:1227/gemini"
export const GEMINI_PROXY_ADDRESS_STREAM = "http://144.34.190.106:1227/geministream"
export const GEMINI_VISION_PROXY_ADDRESS = "http://144.34.190.106:1227/gvision"
export const QWEN_API_KEY = "EMPTY";
export const QWEN_BASE_URL = "http://223.0.30.20:1999/v1"


